
import React      from 'react';
import CSSModules from 'react-css-modules';

import { reduxForm } from 'redux-form';

import authenticator     from '../../services/authenticator';
import responseFormatter from '../../services/responseFormatter';

import {
    HTTP_UNAUTHORIZED,
    HTTP_UNPROCESSABLE_ENTITY
} from '../../services/responseCodes';

import PageHeader    from '../PageHeader';
import InputGroup    from '../InputGroup';
import Label         from '../Label';
import Input         from '../Input';
import Button        from '../Button';
import InlineError   from '../InlineError';
import GlobalMessage from '../GlobalMessage';
import Header from '../Header';

import style from './style.scss';

const login = (values) => {

    function loginSuccess(response) {

        authenticator.storeSessionToken(response.data.data['token']);

        window.location = '/dashboard/events';
    }

    function getGlobalErrorMessage(responseStatusCode) {

        switch (responseStatusCode) {

            case HTTP_UNAUTHORIZED:
                return 'Your email or password is incorrect, please try again.';

            case HTTP_UNPROCESSABLE_ENTITY:
                return 'There was a problem with your email or password.';

            default:
                return 'You cannot be logged in at this time.';

        }
    }

    function loginFailed(response) {

        let globalErrorMessage = getGlobalErrorMessage(response.status);

        throw responseFormatter.apiErrorsToFormErrors(response.data.errors, globalErrorMessage);
    }

    return authenticator.login(values)
        .then(loginSuccess, loginFailed);
};

class LoginPage extends React.Component {

    constructor() {

        super();

        this.state = {
            showSessionExpired: false
        };
    }

    componentDidMount() {

        if (this.props.location.query['expired'] === 'true') {

            this.setState({
                showSessionExpired: true
            });
        }
    }

    render() {

        const { fields: { email, password }, error, handleSubmit, submitting } = this.props;

        return (

            <article styleName="dashboard">

                <Header isDashboard={true}/>

                <div styleName="content">

                    <form onSubmit={ handleSubmit(login) } styleName="panel">

                        <PageHeader title="Sign In" />

                        <div styleName="panel-content">

                            <GlobalMessage className={ style['global-error'] }
                                           type="error"
                                           show={ this.props.pristine && this.state.showSessionExpired }>

                                Your session has expired, please log in again.

                            </GlobalMessage>

                            <GlobalMessage className={ style['global-error'] } type="error" show={ error }>
                                { error }
                            </GlobalMessage>

                            <InputGroup>
                                <Label>Email</Label>
                                <Input { ...email } errors={ email.error } className={ style['textfield']}/>
                                <InlineError errors={ email.error } />
                            </InputGroup>

                            <InputGroup>
                                <Label>Password</Label>
                                <Input { ...password } errors={ password.error } type="password" className={ style['textfield']} />
                                <InlineError errors={ password.error } />
                            </InputGroup>

                            <InputGroup>

                                <Button disabled={ submitting }
                                        type="submit"
                                        className={ style['sign-in-button'] }>

                                    Sign In
                                </Button>

                            </InputGroup>

                        </div>

                    </form>

                </div>

            </article>
        );
    }
}

const reduxFormParams = {
    form: 'login',
    fields: ['email', 'password']
};

export default reduxForm(reduxFormParams)(CSSModules(LoginPage, style));


// WEBPACK FOOTER //
// ./components/LoginPage/index.js